<template>
	<div class="create-job">
		<homeHeader :title="isEdit ? '编辑岗位' : '创建岗位'" />
		<div style="padding: 20px">
			<div class="header">
				<el-breadcrumb separator="/" style="font-size: 16px;">
					<el-breadcrumb-item :to="{ path: '/recruitManage' }">招聘岗位</el-breadcrumb-item>
					<el-breadcrumb-item>{{ isEdit ? '编辑岗位' : '创建岗位' }}</el-breadcrumb-item>
				</el-breadcrumb>
				<!-- <el-button @click="back" type="text" icon="el-icon-arrow-left" style="color: #606266">返回</el-button> -->
			</div>
			<div class="content">
				<h3>岗位基本信息</h3>
				<el-form :model="form" :rules="rules" ref="form" label-width="120px">
					<el-form-item label="公司选择" prop="companyId">
						<span v-if="form.companyName" style="color: #606266; margin-right: 8px;">{{ form.companyName }}</span>
						<el-button type="text" @click="selectCompany">选择公司</el-button>
					</el-form-item>
					<el-form-item label="招聘类型" prop="recruitType">
						<el-select v-model="form.recruitType" placeholder="请选择招聘类型">
							<el-option label="社招" :value="0"></el-option>
							<el-option label="校招" :value="1"></el-option>
							<el-option label="其他" :value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="岗位名称" prop="jobName">
						<el-input v-model="form.jobName" placeholder="请输入岗位名称" />
					</el-form-item>
					<el-form-item label="薪资范围" prop="salaryType">
						<el-radio-group v-model="form.salaryType">
							<el-radio :label="0">浮动薪资</el-radio>
							<el-radio :label="1">面议</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item v-if="form.salaryType === 0" label="薪资区间" prop="minSalary">
						<el-select
							v-model="form.minSalary"
							placeholder="最低薪资"
							style="width: 120px; margin-right: 10px"
						>
							<el-option v-for="i in 100" :key="i" :label="`${i}K`" :value="i"></el-option>
						</el-select>
						-
						<el-select
							v-model="form.maxSalary"
							placeholder="最高薪资"
							style="width: 120px; margin-left: 10px"
						>
							<el-option v-for="i in 100" :key="i" :label="`${i}K`" :value="i"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="岗位描述" prop="introduction">
						<quill-editor
							ref="quillEditor"
							style="line-height: initial;height: 300px;padding-bottom: 66px;"
							v-model="form.introduction"
							:options="editorOption"
							@change="onEditorChange"
						/>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit">提交</el-button>
						<el-button @click="onCancel">取消</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
        <CompanySelectDialog :visible.sync="dialogVisible" @confirm="onCompanyConfirm" />
	</div>
</template>

<script>
import { quillEditor, Quill } from "vue-quill-editor";
import homeHeader from "@/components/homeHeader.vue";
import CompanySelectDialog from "@/components/recruit/CompanySelectDialog.vue";
import { upload, jobRecruit } from "@/services";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

const Font = Quill.import("formats/font");
var fonts = ["SimSun", "SimHei", "Microsoft-YaHei", "KaiTi", "FangSong", "Arial", "Times-New-Roman", "sans-serif"];
Font.whitelist = fonts;
Quill.register(Font, true);

export default {
	name: "CreateJob",
	components: {
		homeHeader,
		quillEditor,
		CompanySelectDialog,
	},
	data() {
		return {
			isEdit: false,
			jobId: this.$route.query.id,
			showCompanyDialog: false,
			form: {
				companyId: "",
				companyName: "",
				recruitType: 0,
				jobName: "",
				salaryType: 0,
				minSalary: "",
				maxSalary: "",
				introduction: "",
				introImgs: [],
			},
			rules: {
				companyId: [{ required: true, message: "请选择公司", trigger: "change" }],
				recruitType: [{ required: true, message: "请选择招聘类型", trigger: "change" }],
				jobName: [{ required: true, message: "请输入岗位名称", trigger: "blur" }],
				salaryType: [{ required: true, message: "请选择薪资范围", trigger: "change" }],
				introduction: [{ required: true, message: "请输入岗位描述", trigger: "blur" }],
				minSalary: [{ required: true, message: "请选择薪资区间", trigger: "blur" }],
			},
			editorOption: {
				modules: {
					toolbar: [
						["bold", "italic", "underline", "strike"],
						["blockquote", "code-block"],
						[{ header: 1 }, { header: 2 }],
						[{ list: "ordered" }, { list: "bullet" }],
						[{ indent: "-1" }, { indent: "+1" }],
						[{ direction: "rtl" }],
						[{ size: ["small", false, "large", "huge"] }],
						[{ header: [1, 2, 3, 4, 5, 6, false] }],
						[{ color: [] }, { background: [] }],
						[{ align: [] }],
						["link", "image"],
					],
				},
				theme: "snow",
				placeholder: "请输入岗位描述",
			},
		};
	},
	computed: {
		dialogVisible: {
			get() {
				return this.showCompanyDialog;
			},
			set(val) {
				this.showCompanyDialog = val;
			},
		},
	},
	mounted() {
		this.initQuill();
		if (this.jobId) {
			this.isEdit = true;
			this.fetchJobDetail();
		}
	},
	methods: {
		initQuill() {
			if (this.$refs.quillEditor) {
				var imgHandler = async (image) => {
					const input = document.createElement("input");
					input.setAttribute("type", "file");
					input.setAttribute("accept", "image/*");
					input.click();
					input.onchange = async () => {
						const file = input.files[0];
						if (file) {
							const isLt = file.size / 1024 / 1024 < 2;
							if (!isLt) {
								this.$message.error("图片大小不超过2M");
								return;
							}
							try {
								const { ok, data } = await upload.file(file, 'image');
								if (ok) {
									const url = data.url;
									const quill = this.$refs.quillEditor.quill;
									const range = quill.getSelection();
									quill.insertEmbed(range.index, "image", url);
									// 处理introImgs，暂时简化
									this.form.introImgs.push(data.data);
								}
							} catch (error) {
								console.error("上传失败", error);
							}
						}
					};
				};
				this.$refs.quillEditor.quill.getModule("toolbar").addHandler("image", imgHandler);
			}
		},
		back() {
			this.$router.push("/recruitManage");
		},
		selectCompany() {
			this.showCompanyDialog = true;
		},
		onCompanyConfirm(selected) {
			this.form.companyId = selected.id;
			this.form.companyName = selected.companyName;
		},
		fetchJobDetail() {
			jobRecruit.getJobDetail(this.jobId).then(({ ok, data }) => {
				if (ok) {
					const job = data.data;
					this.form = {
						companyId: job.companyRecruitId,
						companyName: job.companyName,
						recruitType: job.recruitType,
						jobName: job.jobName,
						salaryType: job.salaryType,
						minSalary: job.minSalary,
						maxSalary: job.maxSalary,
						introduction: job.introduction,
						introImgs: job.introImgs || [],
					};
				}
			}).catch(err => {
				console.error("获取岗位详情失败", err);
				this.$message.error("获取岗位详情失败");
			});
		},
		onEditorChange({ quill, html, text }) {
			this.form.introduction = html;
		},
		onSubmit() {
			this.$refs.form.validate((valid) => {
				if (valid) {
					const data = {
						companyRecruitId: this.form.companyId,
						jobName: this.form.jobName,
						recruitType: this.form.recruitType,
						salaryType: this.form.salaryType,
						minSalary: this.form.salaryType === 0 ? this.form.minSalary : undefined,
						maxSalary: this.form.salaryType === 0 ? this.form.maxSalary : undefined,
						introduction: this.form.introduction,
						introImgs: this.form.introImgs,
					};
					const promise = this.isEdit
						? jobRecruit.updateJob({...data, id: this.jobId})
						: jobRecruit.createJob(data);
					promise
						.then(({ ok }) => {
							if (ok) {
								this.$message.success(this.isEdit ? "编辑成功" : "创建成功");
								this.back();
							}
						})
						.catch((err) => {
							console.error(this.isEdit ? "编辑失败" : "创建失败", err);
							this.$message.error(this.isEdit ? "编辑失败" : "创建失败");
						});
				} else {
					console.log("表单验证失败");
					return false;
				}
			});
		},
		onCancel() {
			this.back();
		},
	},
};
</script>

<style scoped>
.create-job {
    overflow: auto;
    height: 100%;
}

.header {
	margin-bottom: 20px;
}
.content {
	width: 800px;
}
.content h3 {
	margin-bottom: 20px;
}

.quill-editor {
	width: 100%;

	.ql-toolbar {
		border-radius: 2px 2px 0 0;
		background-color: #fff;
		padding: 10px 8px;
	}

	.ql-container {
		height: 300px;
		border-radius: 0px 0px 2px 2px;
	}

	img {
		max-width: 400px;
	}
}
</style>
